import { render, staticRenderFns } from "./MultiAxisChart.vue?vue&type=template&id=5f2b37ce&scoped=true"
import script from "./MultiAxisChart.vue?vue&type=script&lang=js"
export * from "./MultiAxisChart.vue?vue&type=script&lang=js"
import style0 from "./MultiAxisChart.vue?vue&type=style&index=0&id=5f2b37ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b37ce",
  null
  
)

export default component.exports